import { createContext, useContext, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { encryptStorage } from '../../CustomStorage';
import { APP_CONSTANTS } from '../../URLConstants';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [sessionUserData, setSessionUserData] = useState(() => {
    try {
      return encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_USER_DATA);
    } catch (error) {
      console.error('Error retrieving user data from storage:', error);
      return null;
    }
  });

  const [sessionCognitoData, setSessionCognitoData] = useState(() => {
    try {
      const storedCognitoData = encryptStorage.getItem(APP_CONSTANTS.AWS_COGNITO_DATA);
      return storedCognitoData;
    } catch (error) {
      console.error('Error while retrieving AWS data:', error);
      return null;
    }
  });

  const navigate = useNavigate();

  const authenticateSession = (adminData) => {
    try {
      encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, true);
      encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN, adminData?.token);
      encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_DATA, adminData);
      setSessionUserData(adminData);
    } catch (error) {
      console.error('Error storing session data:', error);
    }
  };

  const awsDataSession = (data) => {
    try {
      if (!data) {
        console.error('AWS data is undefined or invalid.');
        return;
      }
      encryptStorage.setItem(APP_CONSTANTS.AWS_COGNITO_DATA, data); // Ensure you're setting it in storage
      setSessionCognitoData(data); // Update React state
    } catch (error) {
      console.error('Error storing AWS data:', error);
    }
  };

  const logoutSession = () => {
    try {
      encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, false);
      encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN, null);
      encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_DATA, null);
      encryptStorage.setItem(APP_CONSTANTS.AWS_COGNITO_DATA, null);
      setSessionCognitoData(null);
      setSessionUserData(null);
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Error clearing session data:', error);
    }
  };

  const contextValue = useMemo(
    () => ({
      sessionUserData,
      authenticateSession,
      logoutSession,
      awsDataSession,
      sessionCognitoData
    }),
    [sessionUserData, sessionCognitoData]
  );

  return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
